import { isRequired, validarEmail } from 'utils/validate/validate';
import { MSG_CAMPO_INVALIDO } from 'utils/consts';

export const validationsCreateUpdate = dadosInputs => {
  const { nomeSetor, descricaoSetor, situacaoId, email } = dadosInputs;
  const errosCampos = {
    nomeSetor: null,
    descricaoSetor: null,
    situacaoId: null,
    email: null,
  };

  errosCampos.email = isRequired(email);
  if (!errosCampos.email) {
    if (!validarEmail(email)) {
      errosCampos.email = MSG_CAMPO_INVALIDO;
    }
  }

  errosCampos.nomeSetor = isRequired(nomeSetor);
  errosCampos.descricaoSetor = isRequired(descricaoSetor);
  errosCampos.situacaoId = isRequired(situacaoId);

  return errosCampos;
};
